export interface INotice {
    type: NoticeTypeEnum,
    message: any
}

export enum NoticeTypeEnum {
    Failure,
    Success
}



// WEBPACK FOOTER //
// ./src/models/notice.ts